<template>
  <v-app>
    <!-- Header -->
    <v-app-bar app color="white" elevation="1" height="60">
      <v-container class="d-flex align-center pa-0" style="max-width:1200px">
        <img src="../../assets/vastrosa-logo.png" alt="Vastrosa" height="40" />
        <v-spacer></v-spacer>
        <span class="grey--text text--darken-1 text-body-2">Privacy Policy</span>
      </v-container>
    </v-app-bar>

    <v-main class="grey lighten-5">
      <v-container class="py-10" style="max-width: 860px">
        <v-card rounded="xxl" elevation="4" class="pa-8">

          <!-- Title -->
          <div class="text-center mb-8">
            <v-icon color="primary" size="56">mdi-shield-lock-outline</v-icon>
            <h1 class="mt-3 text-h4 font-weight-bold">Privacy Policy</h1>
            <p class="grey--text mt-2">Last updated: April 1, 2026</p>
          </div>

          <v-divider class="mb-8"></v-divider>

          <!-- Sections -->
          <div v-for="(section, i) in sections" :key="i" class="mb-8">
            <h2 class="text-h6 font-weight-bold mb-3 d-flex align-center">
              <v-icon color="primary" class="mr-2" size="20">{{ section.icon }}</v-icon>
              {{ section.title }}
            </h2>
            <p
              v-for="(para, j) in section.paragraphs"
              :key="j"
              class="text-body-1 grey--text text--darken-2 mb-2"
              style="line-height: 1.8"
            >
              {{ para }}
            </p>
            <ul v-if="section.bullets" class="pl-4 mt-2">
              <li
                v-for="(bullet, k) in section.bullets"
                :key="k"
                class="text-body-1 grey--text text--darken-2 mb-1"
                style="line-height: 1.8"
              >
                {{ bullet }}
              </li>
            </ul>
          </div>

          <v-divider class="my-8"></v-divider>

          <!-- Contact -->
          <div class="text-center">
            <v-icon color="primary" size="32">mdi-email-outline</v-icon>
            <p class="mt-2 text-body-1 grey--text text--darken-2">
              For any privacy-related questions, contact us at
              <strong>support@vastrosa.com</strong>
            </p>
          </div>

        </v-card>
      </v-container>
    </v-main>

    <!-- Footer -->
    <v-footer color="white" elevation="2" class="py-3">
      <v-container class="text-center pa-0">
        <span class="grey--text text-caption">
          &copy; {{ new Date().getFullYear() }} Vastrosa. All rights reserved.
        </span>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "PrivacyPolicyPage",
  data() {
    return {
      sections: [
        {
          icon: "mdi-information-outline",
          title: "1. Introduction",
          paragraphs: [
            "Welcome to Vastrosa. We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our application.",
            "Please read this policy carefully. If you disagree with its terms, please discontinue use of the application.",
          ],
        },
        {
          icon: "mdi-database-outline",
          title: "2. Information We Collect",
          paragraphs: [
            "We collect information that you voluntarily provide when registering, placing orders, or contacting us. This may include:",
          ],
          bullets: [
            "Full name, email address, and phone number",
            "Shipping and billing address",
            "Payment information (processed securely via third-party providers)",
            "Order history and preferences",
            "Device information and usage data",
          ],
        },
        {
          icon: "mdi-cog-outline",
          title: "3. How We Use Your Information",
          paragraphs: [
            "We use the information we collect to:",
          ],
          bullets: [
            "Process and fulfill your orders",
            "Send order confirmations, updates, and support messages",
            "Improve our application and services",
            "Detect and prevent fraudulent transactions",
            "Comply with legal obligations",
          ],
        },
        {
          icon: "mdi-share-variant-outline",
          title: "4. Sharing of Information",
          paragraphs: [
            "We do not sell, trade, or rent your personal information to third parties. We may share information with trusted partners only to operate our services, such as payment processors and delivery partners, under strict confidentiality agreements.",
          ],
        },
        {
          icon: "mdi-lock-outline",
          title: "5. Data Security",
          paragraphs: [
            "We implement industry-standard security measures including encryption, secure servers, and access controls to protect your personal data from unauthorized access, alteration, disclosure, or destruction.",
            "However, no method of transmission over the internet or electronic storage is 100% secure. We strive to use commercially acceptable means to protect your data but cannot guarantee absolute security.",
          ],
        },
        {
          icon: "mdi-clock-outline",
          title: "6. Data Retention",
          paragraphs: [
            "We retain your personal information for as long as your account is active or as needed to provide services. You may request deletion of your account and data at any time by submitting a request through our Delete Account page.",
          ],
        },
        {
          icon: "mdi-account-check-outline",
          title: "7. Your Rights",
          paragraphs: [
            "You have the right to:",
          ],
          bullets: [
            "Access the personal data we hold about you",
            "Request correction of inaccurate data",
            "Request deletion of your account and personal data",
            "Opt out of marketing communications at any time",
            "Lodge a complaint with the relevant data protection authority",
          ],
        },
        {
          icon: "mdi-cellphone-outline",
          title: "8. Third-Party Services",
          paragraphs: [
            "Our application may contain links or integrations with third-party services (e.g., payment gateways, delivery tracking). We are not responsible for the privacy practices of these third parties and encourage you to review their privacy policies.",
          ],
        },
        {
          icon: "mdi-child-care",
          title: "9. Children's Privacy",
          paragraphs: [
            "Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children. If we become aware that a child has provided us with personal data, we will take steps to delete such information.",
          ],
        },
        {
          icon: "mdi-pencil-outline",
          title: "10. Changes to This Policy",
          paragraphs: [
            "We may update this Privacy Policy from time to time. We will notify you of any significant changes by updating the date at the top of this page. Continued use of the application after changes constitutes acceptance of the updated policy.",
          ],
        },
      ],
    };
  },
};
</script>
